<div *ngIf="!reverse" [ngClass]="{ disabled: isDisabled }">
  <div [ngClass]="className"></div>
  <span *ngIf="text" [class]="size + '-text'">{{ text }}</span>
</div>

<div *ngIf="reverse" [ngClass]="{ disabled: isDisabled }">
  <span *ngIf="text" [class]="size + '-text right'">{{ text }}</span>
  <div [ngClass]="className"></div>
</div>
